module.exports = __webpack_public_path__ + "static/Lessons on Law of Witnesses and Evidence-e7271d39cd6e488d80c91cfbf44ec463.jpg";